import React, { useEffect, useState } from 'react'
import {
  Card,
  Row,
  Col,
  Button,
  Divider,
  Modal,
  Spin,
  Form,
  Input,
  message,
  Tag,
  Table
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import { useHistory } from 'react-router-dom'
import {
  DollarCircleOutlined,
  CreditCardOutlined,
  CaretDownOutlined
} from '@ant-design/icons'
import ds from '../../../Services/DataServices'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { notAllowMsgCheck, setCommonConfigs } from '../../../appRedux/actions'
import { PAYMENT_SCREEN } from '../../../constants/Pages'
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const PaymentTypes = () => {
  const confirm = Modal.confirm
  const [form] = Form.useForm()
  const history = useHistory()
  const dispatch = useDispatch()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [visible, setVisible] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false) // change state
  const [showPaymentDropdown, setShowPaymentDropdown] = useState(false) // Open IsOpen
  const [selectedPaymentOption, setSelectedPaymentOption] = useState()
  const [paymentOption, setPaymentOption] = useState('')
  const [paymentTypeList, setPaymentTypeList] = useState([])
  const [getPayListDropdown, setPayListDropdown] = useState([])
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])

  //rights & permissions
  React.useEffect(() => {
    let commonData = getReduxCommonSetting
    let rites = []
    let permissions = []
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
    ) {
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
          .length > 0
      ) {
        rites =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setRights(rites)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission.length > 0
      ) {
        permissions =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setPermissions(permissions)
      }
    }

    if (rites.length > 0) {
      if (rites.filter(a => a == READ).length > 0) {
        setIsAllowRead(true)
      }
      if (rites.filter(a => a == CREATE).length > 0) {
        setIsDisableCreate(false)
        //redirect from home
        // if (window.location.href.includes("/mainadd")) {
        //   setVisible(true);
        // }
      }
      // else {
      //   if (window.location.href.includes("/mainadd")) {
      //     message.info("User don't have the right to create.");
      //   }
      // }
      if (rites.filter(a => a == UPDATE).length > 0) {
        setIsDisableUpdate(false)
      }
      if (rites.filter(a => a == DELETE).length > 0) {
        setIsDisableDelete(false)
      }
    }

    if (commonData && commonData.storeCommonConfigs) {
      setAccessLoading(false)
    }
  }, [getReduxCommonSetting])

  useEffect(() => {
    dispatch(setCommonConfigs(PAYMENT_SCREEN))
    getPayList()
    setConfirmLoading(true)

    ds.getPaymentTypeList('', BEHAVIOUR_TYPE.GET)
      .then(res => {
        let array = res.map(e => {
          return {
            id: e.paymentTypeSId, //e.paymentTypeSId.substring(0, e.paymentTypeSId.indexOf("&")),
            paymentName: e.paymentTypeName,
            paymentType: e.paymentType,
            payTypeSourceId: e.payTypeSourceId,
            paySourceName: e.paySourceName
          }
        })
        setPaymentTypeList(array)
        setConfirmLoading(false)
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setConfirmLoading(false)
        message.error('Something went wrong')
      })
  }, [])

  async function getPayList () {
    await ds
      .getPayListService('', BEHAVIOUR_TYPE.GET)
      .then(res => {
        if (res && res.length > 0) {
          setPayListDropdown(res)
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        // setTemplatesLoading(false);
        // message.error("Error Occured");
      })
  }

  const handleCancel = () => {
    setVisible(false)
  }

  const redirectAdd = name => {
    if (selectedPaymentOption) {
      history.push(
        `/Dashboard/Setup/PaymentTypes/add/${name}/${selectedPaymentOption}`
      )
    } else message.info('Kindly Select Payment Type', 3)
  }

  const redirectEdit = (id, name, payName) => {
    history.push(
      `/Dashboard/Setup/PaymentTypes/edit/${id}/${name}/${
        getIsDisableDelete ? '0' : '1'
      }${payName ? `/${payName}` : ''}`
    )
  }
  const columns = [
    {
      title: '',
      dataIndex: 'paymentName',
      key: 'paymentName',
      render: (text, record) => {
        return (
          <>
            <div
              className='gx-icon-text option-name'
              onClick={() =>
                redirectEdit(
                  record.id,
                  record.payTypeSourceId,
                  record.paySourceName
                )
              }
            >
              <h3 className='mb-0 float-left'>
                {record.payTypeSourceId.substring(
                  0,
                  record.payTypeSourceId.indexOf('&')
                ) == '1' ? (
                  <DollarCircleOutlined className='mr-2 float-left' />
                ) : (
                  <CreditCardOutlined className='mr-2 float-left' />
                )}
                {record.paymentName}
              </h3>
            </div>
          </>
        )
      }
    },

    {
      title: '',
      key: 'edit',
      render: (text, record) => {
        return (
          <>
            <div className='dk-txt-align-rt'>
              {getIsDisableUpdate ? (
                <Tag color='#f50'>
                  <strong>
                    <IntlMessages id='dakarpos.allow.accessdenied' />
                  </strong>
                </Tag>
              ) : (
                <div
                  className='pen-edit'
                  onClick={() =>
                    redirectEdit(
                      record.id,
                      record.payTypeSourceId,
                      record.paySourceName
                    )
                  }
                >
                  <i className='icon icon-edit' />
                </div>
              )}
            </div>
          </>
        )
      }
    }
  ]
  const onOptionClicked = (val, sourceID) => {
    setSelectedPaymentOption(val)
    setShowPaymentDropdown(false)
    setPaymentOption(sourceID)
    //console.log("paymentOption",paymentOption);
  }

  return getIsAllowRead ? (
    <Spin
      tip={<IntlMessages id='sell.cashlisting.cashloading' />}
      spinning={confirmLoading}
      size='large'
    >
      <>
        <div className='Content-wrapper PaymentTypes-pg'>
          <Row className='align-items-center justify-content-center mb-3 RegisterClosureSummary-header'>
            <Col lg={12} md={12} sm={16} xs={24}>
              <h1 className='mb-0'>
                {' '}
                <IntlMessages id='setup.paymentTypesTitle' />{' '}
              </h1>
              <p className='mb-0'>
                {' '}
                <IntlMessages id='setup.paymentTypes.helpDescription' />{' '}
              </p>
            </Col>
            <Col lg={12} md={12} sm={8} xs={24} className='text-right'>
              <Button
                className='dk-btn-add'
                type='primary'
                onClick={() => setVisible(true)}
                disabled={getIsDisableCreate}
                size='large'
              >
                <IntlMessages id='setup.paymentTypes.addPayTypeButton' />
              </Button>
            </Col>
          </Row>

          <Table
            className='gx-table-responsive mt-5'
            columns={columns}
            showHeader={false}
            dataSource={paymentTypeList}
            pagination={false}
          />

          <Modal
            title={
              <h2 className='dk-payment-modal-header'>
                <IntlMessages id='setup.paymentTypes.modalTitle' />
              </h2>
            }
            visible={visible}
            okText={<IntlMessages id='setup.paymentTypes.beginSetup' />}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            onOk={() => redirectAdd(paymentOption)}
            width={700}
            centered={true}
            okButtonProps={{
              className: ''
            }}
            cancelButtonProps={{
              className: 'dk-btn-cancel'
            }}
          >
            <Col md={24} className='p-0'>
              <div
                className='choose-payment-type'
                onClick={() => setShowPaymentDropdown(!showPaymentDropdown)}
              >
                {selectedPaymentOption ? (
                  selectedPaymentOption
                ) : (
                  <IntlMessages id='setup.paymentTypes.choosePayType' />
                )}
                <CaretDownOutlined />
              </div>
            </Col>
            {showPaymentDropdown ? (
              <Card className='payment-option-list'>
                <Col md={24} className='p-0'>
                  <h3 className='add-personal-tokens-header'>
                    <IntlMessages id='setup.paymentTypes.searchPayType' />
                  </h3>

                  {getPayListDropdown &&
                    getPayListDropdown.length > 0 &&
                    _.uniqBy(getPayListDropdown, 'key').map((a, key) => {
                      return (
                        <div key={key} className='payment-option-detail'>
                          <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                              <h3 style={{ textDecoration: 'underline' }}>
                                {a.payTypeSourceGroupName &&
                                  a.payTypeSourceGroupName != '' &&
                                  a.payTypeSourceGroupName
                                    .toLowerCase()
                                    .includes('general') && (
                                    <IntlMessages id='pay.scree.geenral' />
                                  )}

                                {a.payTypeSourceGroupName &&
                                  a.payTypeSourceGroupName != '' &&
                                  a.payTypeSourceGroupName
                                    .toLowerCase()
                                    .includes('online') && (
                                    <IntlMessages id='pay.scree.online' />
                                  )}

                                {a.payTypeSourceGroupName &&
                                  a.payTypeSourceGroupName != '' &&
                                  a.payTypeSourceGroupName
                                    .toLowerCase()
                                    .includes('terminals') &&
                                  a.payTypeSourceGroupName}
                              </h3>
                            </Col>
                          </Row>

                          {getPayListDropdown
                            .filter(s => s.key == a.key)
                            .map((d, key) => {
                              let color = 'blue'
                              if (
                                d.payTypeSourceName &&
                                d.payTypeSourceName.includes('CASH')
                              ) {
                                color = 'purple'
                              } else if (key == 0) {
                                color = 'amber'
                              } else if (key == 1) {
                                color = 'green'
                              }
                              return (
                                <Row key={key}>
                                  <Col span={22}>
                                    <p
                                      className='mb-0'
                                      onClick={() =>
                                        onOptionClicked(
                                          d.payTypeSourceName,
                                          d.payTypeSourceId
                                        )
                                      }
                                    >
                                      <i
                                        class={`icon icon-tag gx-text-${color} float-left`}
                                      ></i>
                                      <span className='custom-payment-type'>
                                        {d.payTypeSourceName}
                                      </span>
                                    </p>
                                  </Col>
                                </Row>
                              )
                            })}
                        </div>
                      )
                    })}
                </Col>
              </Card>
            ) : null}
          </Modal>
        </div>
      </>
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default PaymentTypes
